var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 117,
    viewBox: "0 0 118 117",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.2373 86.9952C14.3328 71.0909 14.3328 45.3741 30.2373 29.4698C46.1417 13.5655 71.8588 13.5655 87.7632 29.4698C103.668 45.3741 103.668 71.0908 87.7632 86.9952C71.8588 102.899 46.1417 102.899 30.2373 86.9952Z",
    stroke: "#0B161A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0995 74.3321L44.0995 41.1053L48.8951 41.1053L48.8951 69.5365L77.3266 69.5365L77.3266 74.3321L44.0995 74.3321Z",
    fill: "#FC8056"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9011 41.1052L77.3266 44.5307L48.2101 73.6469L44.7846 70.2215L73.9011 41.1052Z",
    fill: "#FC8056"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowicon);
export default __webpack_public_path__ + "static/media/Arrowicon.09f46d87678d7997000e32a8c534036e.svg";
export { ForwardRef as ReactComponent };